<template>
  <van-config-provider :theme-vars="themeVars">
  <div class="van-hairline--surround">
       <van-cell-group inset border="false">
         <h3 style="padding-top: 1em;">镖计划</h3>
         <p class="textIndentation">镖计划，是由深圳镖计划科技信息有限公司发起，与保险公司一并建议的知识产权保障平台。整合国内外顶级的律师资源，一站式
          为涉外企业的知识产权保驾护航。
         </p>
       </van-cell-group>
   </div>
 </van-config-provider>
<br/>
   <div class="van-hairline--surround">
        <van-cell-group inset>
         <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">适合参与此项目的企业或个人:</van-divider>
       <p class="match"><van-notice-bar color="#1989fa" left-icon="friends-o">
           产品服务主要销往欧洲、美国等地
         </van-notice-bar>
         <van-notice-bar wrapable :scrollable="false" color="#1989fa" left-icon="logistics">
           企业的产品具有独特的创新，产品创新是企业生命线
         </van-notice-bar>
         <van-notice-bar wrapable :scrollable="false" color="#1989fa" left-icon="warn-o">
           潜在行业竞争激烈，且有国外有同等竞争对手
         </van-notice-bar>
         <van-notice-bar wrapable :scrollable="false" color="#1989fa" left-icon="more-o">
           过去涉及法律诉讼，无论是被告还是原告
         </van-notice-bar>
         <van-notice-bar color="#1989fa" left-icon="closed-eye">
           未全面评估知识产权风险
         </van-notice-bar>
         <van-notice-bar wrapable :scrollable="false" left-icon="setting-o">
          如果您有这方面情况，我们建议您入驻参加我们，我们会免费为您的业务进行风险评估
         </van-notice-bar>
         <van-button color="linear-gradient(to right, #f67f34, #d55809)" block size="large" to="binding">立即入驻</van-button>
       </p>
     </van-cell-group>
   </div>
   <br/>
   <div class="van-hairline--surround">
        <van-cell-group inset>
         <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">较早做好产权保护，可以有效减少突发问题的影响</van-divider>
         <van-image src="https://coipor-1323220137.cos.ap-nanjing.myqcloud.com/item1.png" />
     </van-cell-group>
   </div>
   <br/>
   <div class="van-hairline--surround">
        <van-cell-group inset>
         <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">90%的企业或个人，在涉诉前并未意识知识产权的风险</van-divider>
         <van-image src="https://coipor-1323220137.cos.ap-nanjing.myqcloud.com/item2.png" />
     </van-cell-group>
   </div>
   <br/>
   <div class="van-hairline--surround">
        <van-cell-group inset>
         <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">专业的团队，在涉外服务部分起到决定作用</van-divider>
         <van-image src="https://coipor-1323220137.cos.ap-nanjing.myqcloud.com/item3.png" />
     </van-cell-group>
   </div>
   <br/>
 <van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }">镖计划具备最健全的知识产权保护服务</van-divider>
 <van-config-provider :theme-vars="themeVars2">
   <div class="van-hairline--surround">
     <van-cell-group inset border="false">
       <p class="text3Indentation">1、我们已经为1万+涉外企业或个人提供过基于知识产权的保护建议和方案</p>
       <p class="text3Indentation">2、国内首创的金融保障方式，进一步降低企业或个人的涉诉损失风险</p>
       <p class="text3Indentation">3、全套闭环服务流程，一站式解决企业或个人的涉诉所有问题</p>
     </van-cell-group>
   </div>
   <div style="margin: 16px;">
   <van-button color="linear-gradient(to right, #f67f34, #d55809)" block size="large" to="/binding">我想参与</van-button>
 </div>
 </van-config-provider>
</template>
<script>
import { reactive, onMounted } from 'vue';
export default {
 setup() {
   const themeVars = reactive({
     cellGroupBackground: '#F1F1F1',
   });
   const kpian = reactive({
     cellGroupBackground: '#AAAAAA',
   });
   const kpianawait = reactive({
     cellGroupBackground: '#F1F1F1',
   });
   const themeVars2 = reactive({
     cellGroupBackground: '#F1F1F1',
   });
  

   onMounted(() => {
   
   
   })
   return {
     themeVars,
     kpian,
     kpianawait,
     themeVars2,
   }
 }
}
</script>
<style scoped>
#app {
 font-family: Avenir, Helvetica, Arial, sans-serif;
 -webkit-font-smoothing: antialiased;
 -moz-osx-font-smoothing: grayscale;
 text-align: center;
 color: #2c3e50;
}
.textIndentation {
 text-align: left;
 text-indent: 2em;
 font-weight: bold;
 font-size: 14px;
 padding-top: 1em;
 padding-right: 1em;
 padding-bottom: 1em;
 padding-left: 1em;
 line-height:30px;
}

.text2Indentation {
 text-align: left;
 text-indent: 2em;
 font-weight: bold;
 font-size: 14px;
 padding-top: 1px;
 padding-right: 1em;
 padding-bottom: 1em;
 padding-left: 1em;
}

.match {
 text-align: left;
 text-indent: 1em;
 font-size: 14px;
}

.text3Indentation {
 text-align: left;
 font-weight: bold;
 font-size: 14px;
 padding-top: 1em;
 padding-right: 1em;
 padding-bottom: 1em;
 padding-left: 1em;
}
</style>
